export const environment = {
  production: false,
  version: '1.0.0',
  serverUrl: "https://dev.locaviaweb.com.br/reservas/api",
  serverAuthUrl: "https://dev.locaviaweb.com.br/reservas/api",
  defaultLanguage: 'pt-BR',
  defaultDateInput: 'DD/MM/YYYY',
  supportedLanguages: ['pt-BR', 'en-US', 'es'],
  username: 'infosistemas',
  password: 'lqWxmxCIK8Y78E3',
  stripeKey: "pk_test_51QU6JU1VMtpa4RFhOgvMnaqObvBFXKx5zgekTD6qWisTUn6zSjLgXby0fJmCmKBkNgXf7Qz9Jq3tjhZh3NFbpwVw00hbo03foZ"
};
